import { render, staticRenderFns } from "./brochure-information.vue?vue&type=template&id=1f7f7f7f&scoped=true"
var script = {}
import style0 from "./brochure-information.vue?vue&type=style&index=0&id=1f7f7f7f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7f7f7f",
  null
  
)

export default component.exports